import { Component } from '@angular/core';
import { CompanyLicenseLoginService } from '../../services/company-license-login.service';

@Component({
  selector: 'app-company-license-modal',
  templateUrl: './company-license-modal.component.html',
  styleUrls: ['./company-license-modal.component.scss']
})
export class CompanyLicenseModalComponent {

  constructor(public licenseLoginService: CompanyLicenseLoginService) { }

  acknowledgeWarning() {
    this.licenseLoginService.acknowledgeWarning();
  }

  closeError() {
    this.licenseLoginService.closeError();
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src2138078126/src/src/app/shared/components/company-license-modal/company-license-modal.component.ts